import React from "react";

import { css } from "@emotion/core";
import { tableItem } from "../ChangePlanSummary";

const rebrandInvoiceTotalCss = css`
  font-weight: 700;
`;

export const InvoiceHeader = () => {
  return (
    <div css={[rebrandInvoiceTotalCss, tableItem]}>
      <span>Description</span>
      <span>Amount</span>
    </div>
  );
};
